import React from 'react';
import Store from '../../../store';

// The fields this renderer reads off a tree node. react-d3-tree v3 passes the
// whole datum through to renderCustomNodeElement untouched, so everything
// TreeStructure carries survives the trip and can be read here.
export interface TreeNodeDatum {
  name: string;
  percentPopulation: number;
  population?: number;
  conversions?: number;
  color?: string;
}

interface NodeLabelProps {
  nodeId: number;
  nodeDatum: TreeNodeDatum;
  store: Store;
}

export default class NodeLabel extends React.PureComponent<NodeLabelProps> {
  render() {
    const { nodeId, nodeDatum } = this.props;
    const populationRatio = nodeDatum.percentPopulation;
    const nodeIndex = parseInt(nodeDatum.name, 10);

    const isSelected = nodeIndex === nodeId;

    // Adapt UI to node data
    const color = isSelected ? '#ffc107' : nodeDatum.color;
    const scale: number = 0.7 * Math.exp(populationRatio);

    const nodeStyle = {
      position: 'relative' as const,
      background: color ? color : '#1e77cc',
      width: 60,
      height: 60,
      transform: `translate(50%, 50%) scale(${scale < 1 ? 1 : scale})`,
      borderRadius: '50%',
    };

    const indexStyle = {
      position: 'absolute' as const,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: isSelected ? '#000' : '#fff',
      fontSize: 30,
    };

    return (
      <div style={nodeStyle}>
        <p style={indexStyle}>{nodeIndex}</p>
      </div>
    );
  }
}
